import React from 'react'

const DarksaveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.1172 14.9635V13.408C11.1172 11.9414 11.1172 11.2081 10.6616 10.7525C10.2059 10.2969 9.47265 10.2969 8.00608 10.2969H7.2283C5.76171 10.2969 5.02841 10.2969 4.5728 10.7525C4.11719 11.2081 4.11719 11.9414 4.11719 13.408V14.9635" stroke="#222222" strokeWidth="1.5" />
            <path d="M4.11719 4.9375H8.00608" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M1 5.66667C1 3.46678 1 2.36684 1.68342 1.68342C2.36684 1 3.46678 1 5.66667 1H11.2446C11.5625 1 11.7214 1 11.8644 1.0592C12.0073 1.11841 12.1197 1.23081 12.3445 1.45561L14.5444 3.6555C14.7692 3.8803 14.8816 3.9927 14.9408 4.13563C15 4.27857 15 4.43753 15 4.75545V10.3333C15 12.5332 15 13.6331 14.3166 14.3166C13.6331 15 12.5332 15 10.3333 15H5.66667C3.46678 15 2.36684 15 1.68342 14.3166C1 13.6331 1 12.5332 1 10.3333V5.66667Z" stroke="#222222" strokeWidth="1.5" />
        </svg>
    )
}

export default DarksaveIcon